import { render, staticRenderFns } from "./setting-style.vue?vue&type=template&id=c01a98ec&scoped=true"
import script from "./setting-style.vue?vue&type=script&lang=js"
export * from "./setting-style.vue?vue&type=script&lang=js"
import style0 from "./setting-style.vue?vue&type=style&index=0&id=c01a98ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01a98ec",
  null
  
)

export default component.exports